<template>
  <div class="service-tile">
    <div class="content-container" @click="modalVisible = true">
      <div class="is-flex">
        <div class="is-expanded">
          <h1 class="is-size-7 has-text-weight-bold">{{ service.engineer.name }}</h1>
          <h1 class="is-size-5">{{ service.customerName }}</h1>
          <p class="is-size-6">{{ service.contactPerson }}</p>
          <p class="is-size-6">{{ service.contactNumber }}</p>
        </div>
        <div class="has-text-right">
          <p
            class="is-size-7 is-uppercase"
            :class="{
              'has-text-danger': service.serviceType === 'breakdown',
              'has-text-warning': service.serviceType === 'maintenance',
              'has-text-info': service.serviceType === 'installation'
            }"
          >{{ service.serviceType }}</p>
          <p
            class="is-size-7 is-uppercase"
            :class="{
              'has-text-info': service.visitType === 'warranty',
              'has-text-warning': service.visitType === 'contract',
              'has-text-grey': service.visitType === 'free',
              'has-text-success': service.visitType === 'chargeable'
            }"
          >{{ service.visitType }}</p>
          <p
            class="is-size-7 is-uppercase"
            :class="{
              'has-text-success': service.status === 'completed',
              'has-text-warning': service.status === 'pending'
            }"
          >{{ service.status }}</p>
        </div>
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': modalVisible }">
      <div class="modal-background" @click="onModalClose"></div>
      <div class="modal-content">
        <div class="box">
          <ul>
            <li class="list-item">
              <router-link :to="`/request/service/view/${service._id}`" class="has-text-grey">View</router-link>
            </li>
            <li class="list-item">
              <router-link :to="`/request/service/edit/${service._id}`" class="has-text-grey">Edit</router-link>
            </li>
            <li class="list-item">
              <router-link
                :to="`/request/service/delete/${service._id}`"
                class="has-text-danger"
              >Delete</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-close" @click="onModalClose"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["service"],
  data() {
    return {
      modalVisible: false
    };
  },
  methods: {
    onModalClose() {
      let component = this;
      component.modalVisible = false;
      console.log("modal-close");
    }
  }
};
</script>
<style lang="scss" scoped>
.service-tile {
  border-bottom: 1px solid $white-ter;
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  &:last-of-type {
    border-bottom-color: transparent;
  }

  .modal {
    .box {
      width: 95%;
      margin: auto;
      text-align: center;
    }
  }
}
</style>
